import ControlContainer from '../Control/Container'

export default function ZoneControlContainer({ selectedZone }) {
  return <ControlContainer selectedZone={selectedZone} />
}
